module.exports = __webpack_public_path__ + "img/icon_web1.b76d9284.svg";